import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=879acbc0&scoped=true&"
import script from "./EditProduct.vue?vue&type=script&lang=js&"
export * from "./EditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879acbc0",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QForm,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QMarkupTable,QDialog,QCardSection,QSelect,QInput,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QForm,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QMarkupTable,QDialog,QCardSection,QSelect,QInput,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
